import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  idPlano: number;
  title = 'Portal Ressarcimento';

  constructor(
    private activatedRoute: ActivatedRoute) {
  }

  ngAfterViewInit() {
     
  }

}
